<template>
    <div class="DatePickerView u-InputMarginView"
        :class="[modes.map((m) => `DatePickerView--${m}`), { 'DatePickerView--error': isError && required }]"
        :style="{ maxWidth: maxWidth, minWidth: minWidth, margin: margin }">
        <!-- <span class="DatePickerView" v-if="required">*</span> -->
        <label class="DatePickerViewLabel" :for="`DatePickerView-input-${_uid}`" v-if="title">
            {{ title }}
        </label>

        <date-picker class="DatePickerViewInput" :class="{ mixed: isMixed && !isReplaceValue }" v-model="innerValue"
            lang="en" value-type="YYYY.MM.DD" :type="type" :format="format" :time-picker-options="timePickerOptions"
            :placeholder="placeholder" :clearable="clearable" />

        <svg-view name="calendar" />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DatePicker from 'vue2-datepicker';

export default {
    name: 'DatePickerView',
    components: { DatePicker },
    mixins: [mixins.ValidationComponentMixin],
    props: {
        title: { type: String, default: '' },
        required: { type: Boolean, default: false },
        value: { type: [Object, String, Date], default: '' },
        placeholder: { type: String, default: '' },
        modes: { type: Array, default: () => [] },
        type: { type: String, default: 'date' },
        clearable: { type: Boolean, default: false },
        format: { type: String, default: 'DD.MM.YYYY' },
        timePickerOptions: { type: Object, default: null },
        maxWidth: { type: String, default: '' },
        minWidth: { type: String, default: '' },
        height: { type: String, default: '' },
        margin: { type: String, default: '' },
        isError: { type: Boolean, default: false },
        isMixed: { type: Boolean, default: false },
    },
    data() {
        return {
            isReplaceValue: false
        }
    },
    watch: {
        value: {
            handler(newValue, oldValue) {
                if (oldValue && newValue !== oldValue && this.isMixed) {
                    const files = this.selectFile
                    this.setClearSelectFile()

                    files.forEach(item => {
                        const template = { ...item }
                        template.date = newValue
                        this.setSelectFile(template)

                        this.setReplaceObjectInLists({
                            listName: `list-${this.selectedEntityId}`,
                            oldObject: item,
                            newObject: template
                        })
                    })

                    this.isReplaceValue = true
                }
            },
            immediate: true
        },
        isMixed: {
            handler() {
                this.isReplaceValue = false
            },
            immediate: true
        }
    },
    computed: {
        ...mapState(['selectFile', 'selectedEntityId']),
    },
    methods: {
        ...mapMutations(['setReplaceObjectInLists', 'setClearSelectFile', 'setSelectFile']),
    }
};
</script>

<style lang="less">
@import "~styles/const.less";
@import "~vue2-datepicker/index.css";

.DatePickerView {
    position: relative;
    margin-top: 25px;
    width: 100%;
    font-family: @Graphik-LCG;

    // &Required {
    //     color: #A6A6A6;
    //     position: absolute;
    //     bottom: 7px;
    //     left: -23px;
    // }

    &Label {
        color: black;
        font-size: 12px;
        line-height: 16px;
    }

    &--error {
        .DatePickerViewRequired {
            color: @color-red;
        }

        .mx-input-wrapper input {
            border-color: red;
        }

        input {
            border-color: red;
        }
    }

    &Input {
        display: block;
        width: 100% !important;
        outline: none;
        font-weight: @regular;
        color: @color-black;
        background-color: transparent;
        font-size: 12px;
        line-height: 16px;
        margin-top: 10px;

        &::placeholder {
            color: #B3B3B3;
        }

        svg {
            display: none;
        }

        .mx-input {
            border-radius: 0;
            border: none;
            outline: none;
            background-color: transparent;
            padding: 0;
            font-size: 12px;
            line-height: 16px;
            color: black;
            box-shadow: none;
            cursor: pointer;
            height: 40px;
            padding: 12px 15px;
            font-family: @Graphik-LCG;
            border: 1px solid #B3B3B3;

            &::placeholder {
                color: @color-placeholder;
            }
        }
    }
}

.mx-datepicker {
    &.mixed {
        .mx-input-wrapper {
            position: relative;

            &::before {
                position: absolute;
                left: 0;
                top: 0;
                content: 'Mixed';
                font-size: 15px;
                line-height: 23px;
            }
        }

        .mx-input {
            opacity: 0 !important;
        }
    }
}

.mx-calendar {
    color: @color-black;
}

.mx-table-date td.today {
    color: @color-link;
}

.mx-calendar-content .cell {
    vertical-align: middle;
}

.mx-calendar-content .cell.active {
    background: @color-link;

    &.today {
        color: @color-white;
    }
}

.svg--calendar {
    position: absolute;
    width: 24px;
    height: 20px;
    bottom: 10px;
    right: 10px;
    z-index: 1;
}
</style>
